import { createApiClient } from './apiClient'
import type { AccessUser, PermissionModule, Role, RolePayload, SessionUser } from '../../pages/access/types'

// touch-api /api/v1/access (touch-api/docs/rbac.md)
const api = createApiClient('/v1/access')

type One<T> = { data: T }

export const fetchMe = async () => (await api.get<One<SessionUser>>('/me')).data.data
export const fetchPermissionCatalog = async () =>
  (await api.get<One<{ modules: PermissionModule[] }>>('/permissions')).data.data.modules
export const fetchRoles = async () => (await api.get<One<Role[]>>('/roles')).data.data
export const createRole = async (body: RolePayload) => (await api.post<One<Role>>('/roles', body)).data.data
export const updateRole = async (id: string, body: Partial<RolePayload>) =>
  (await api.put<One<Role>>(`/roles/${id}`, body)).data.data
export const deleteRole = async (id: string) => (await api.delete<One<{ id: string }>>(`/roles/${id}`)).data.data
export const fetchUserAccess = async (id: string) => (await api.get<One<AccessUser>>(`/users/${id}`)).data.data
export const saveUserOverrides = async (id: string, body: { grant: string[]; deny: string[] }) =>
  (await api.put<One<AccessUser>>(`/users/${id}/overrides`, body)).data.data
export const revokeSessions = async (id: string) =>
  (await api.post<One<{ id: string }>>(`/users/${id}/revoke-sessions`)).data.data
